(function () {
  'use strict';

  // -----------------------------
  // Configuration
  // -----------------------------
  var RESTRICTED_VEHICLE_MATCHERS = [
    '2011-2026 dodge/ram 4500/5500 - 10x225/170.1mm cb',
    '2005-2026 ford f-450/f-550 drw - 10x225/170.1mm cb'
  ];

  var RESTRICTED_DESIGN_TITLES = [
    'liberty hdd - 09',
    'bolt hdd - 23'
  ];

  var POPUP_MESSAGE =
    'This wheel design is <span class="wdr-strong">NOT COMPATIBLE</span> with your selected vehicle. ' +
    'Only select designs are available in a 10x225 bolt pattern.';

  var DEBUG = false;

  var hasShownPopupForCurrentCombo = false;
  var lastStateKey = '';

  // -----------------------------
  // Styles
  // -----------------------------
  function injectStyles() {
  if (document.getElementById('wdr-styles')) return;
  var style = document.createElement('style');
  style.id = 'wdr-styles';
  style.textContent = [
    '@import url("https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap");',

    '.wdr-overlay{position:fixed;inset:0;background:rgba(0,0,0,0.75);z-index:99998;}',

    '.wdr-modal{',
      'position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);',
      'z-index:99999;width:90%;max-width:400px;',
      'background:#CDCDCD;border-radius:4px;overflow:hidden;',
      'box-shadow:0 0 0 1px #b0b0b0;font-family:Arial,sans-serif;',
    '}',

    '.wdr-header{',
      'background:#111111;padding:18px 22px;',
      'display:flex;align-items:center;justify-content:center;gap:14px;',
    '}',

    '.wdr-icon{',
      'width:34px;height:34px;border-radius:50%;background:#B1282E;',
      'display:flex;align-items:center;justify-content:center;flex-shrink:0;',
    '}',

    '.wdr-icon svg{display:block;}',

    '.wdr-title{',
      'font-family:"Bebas Neue",Impact,sans-serif;',
      'color:#fff !important;font-size:28px;letter-spacing:0px;line-height:1;',
    '}',

    '.wdr-bar{height:3px;background:#B1282E;}',

    '.wdr-body{padding:20px 22px 16px;text-align:center;}',

    '.wdr-desc{',
      'font-family:"Bebas Neue",Impact,sans-serif;',
      'font-size:21px;letter-spacing:0px;color:#444;line-height:1.55;',
      'margin:0 0 16px;',
    '}',

    '.wdr-strong{color:#111 !important;}',

    '.wdr-subheading{',
      'font-family:"Bebas Neue",Impact,sans-serif;',
      'font-size:21px;letter-spacing:0px;color:#111;',
      'margin:0 0 10px;',
    '}',

    '.wdr-chips{display:flex !important;flex-wrap:wrap;gap:7px;justify-content:center;}',

    '.wdr-chips a{',
      'display:inline-block !important;',
      'color:#fff !important;',
      'background:#B1282E !important;',
      'font-family:"Bebas Neue",Impact,sans-serif !important;',
      'font-size:19px !important;',
      'letter-spacing:0px !important;',
      'text-decoration:none !important;',
      'padding:6px 13px !important;',
      'border-radius:3px !important;',
      'line-height:1.3 !important;',
      'transition:background 0.15s ease,color 0.15s ease !important;',
    '}',

    '.wdr-modal .wdr-chips a:focus,.wdr-modal .wdr-chips a:focus-visible{',
      'background:#ffffff !important;',
      'color:#B1282E !important;',
      'outline:2px solid #111111 !important;',
      'outline-offset:2px !important;',
    '}',

    '.wdr-footer{',
      'padding:14px 22px 22px;',
      'border-top:1px solid #b8b8b8;',
    '}',

    '.wdr-btn{',
      'width:100%;background:#111;color:#fff;border:none;border-radius:3px;',
      'padding:13px;cursor:pointer;',
      'font-family:"Bebas Neue",Impact,sans-serif;',
      'font-size:24px;letter-spacing:0px;',
    '}',

    '.wdr-btn:focus-visible{outline:3px solid #B1282E !important;outline-offset:3px !important;}',

    '@media(max-width:480px){',
      '.wdr-title{font-size:22px;}',
      '.wdr-desc{font-size:17px;}',
      '.wdr-subheading{font-size:17px;}',
      '.wdr-chips a{font-size:16px !important;}',
      '.wdr-btn{font-size:20px;}',
    '}'

  ].join('');
  document.head.appendChild(style);
}

  // -----------------------------
  // Helpers
  // -----------------------------
  function norm(s) {
    return String(s || '')
      .trim()
      .toLowerCase()
      .replace(/[""]/g, '"')
      .replace(/[–—]/g, '-')
      .replace(/\s+/g, ' ');
  }

  function getSelectedSnapshot() {
    var parts = [];

    var propInputsGlobal = document.querySelectorAll('[name^="properties["]');
    for (var i = 0; i < propInputsGlobal.length; i++) {
      var inp = propInputsGlobal[i];
      if (!inp) continue;
      var val = '';
      if (inp.type === 'checkbox') {
        if (!inp.checked) continue;
        val = inp.value || 'true';
      } else if (inp.type === 'radio') {
        if (!inp.checked) continue;
        val = inp.value || '';
      } else {
        val = inp.value || '';
      }
      val = norm(val);
      if (val) parts.push(val);
    }
    if (parts.length) return parts.join(' | ');

    var els = document.querySelectorAll('.po-dropdown-selected-option');
    for (var j = 0; j < els.length; j++) {
      var t = norm(els[j].textContent);
      if (t) parts.push(t);
    }
    if (parts.length) return parts.join(' | ');

    var generic = document.querySelectorAll(
      '[data-selected-value], .selected-value, .option-selected, .swatch__selected'
    );
    for (var k = 0; k < generic.length; k++) {
      var t2 = norm(
        generic[k].textContent || generic[k].getAttribute('data-selected-value')
      );
      if (t2) parts.push(t2);
    }

    return parts.join(' | ');
  }

  function getProductTitle() {
    var h1 = document.querySelector('h1');
    var title = h1 ? h1.textContent : document.title;
    return norm(title);
  }

  function isRestrictedDesignOnPage() {
    var title = getProductTitle();
    for (var i = 0; i < RESTRICTED_DESIGN_TITLES.length; i++) {
      var d = norm(RESTRICTED_DESIGN_TITLES[i]);
      if (title === d || title.indexOf(d) !== -1) return true;
    }
    return false;
  }

  function isRestrictedVehicleSelected(snapshot) {
    var snap = snapshot || getSelectedSnapshot();
    for (var i = 0; i < RESTRICTED_VEHICLE_MATCHERS.length; i++) {
      if (snap.indexOf(norm(RESTRICTED_VEHICLE_MATCHERS[i])) !== -1) return true;
    }
    return false;
  }

  // -----------------------------
  // Add to Cart blocking
  // -----------------------------
  function getAddToCartButtons() {
    return document.querySelectorAll(
      'form[action^="/cart/add"] [type="submit"], ' +
      'form[action^="/cart/add"] button[name="add"], ' +
      'button[name="add"], ' +
      'button[type="submit"][name="add"]'
    );
  }

  function setAddToCartDisabled(disabled) {
    var buttons = getAddToCartButtons();
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      btn.disabled = !!disabled;
      btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      if (disabled) {
        btn.style.opacity = '0.5';
        btn.style.cursor = 'not-allowed';
      } else {
        btn.style.opacity = '';
        btn.style.cursor = '';
      }
    }
  }

  function preventAddToCartWhenRestricted() {
    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || !form.matches || !form.matches('form[action^="/cart/add"]')) return;
        var snap = getSelectedSnapshot();
        var restricted = isRestrictedDesignOnPage() && isRestrictedVehicleSelected(snap);
        if (restricted) {
          e.preventDefault();
          e.stopPropagation();
          hasShownPopupForCurrentCombo = false;
          checkRestrictions(snap);
          return false;
        }
      },
      true
    );

    var originalFetch = window.fetch;
    if (originalFetch) {
      window.fetch = function () {
        try {
          var url = arguments[0];
          var urlStr = typeof url === 'string' ? url : (url && url.url) ? url.url : '';
          if (urlStr && (urlStr.indexOf('/cart/add') !== -1 || urlStr.indexOf('/cart/add.js') !== -1)) {
            var snap2 = getSelectedSnapshot();
            var restricted2 = isRestrictedDesignOnPage() && isRestrictedVehicleSelected(snap2);
            if (restricted2) {
              hasShownPopupForCurrentCombo = false;
              checkRestrictions(snap2);
              return Promise.reject(new Error('Restricted combination blocked.'));
            }
          }
        } catch (err) {}
        return originalFetch.apply(this, arguments);
      };
    }
  }

  // -----------------------------
  // Popup
  // -----------------------------
  function showPopup() {
    if (document.querySelector('.wdr-modal') || hasShownPopupForCurrentCombo) return;
    hasShownPopupForCurrentCombo = true;

    var previouslyFocused = document.activeElement;

    var overlay = document.createElement('div');
    overlay.className = 'wdr-overlay';

    var modal = document.createElement('div');
    modal.className = 'wdr-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'wdr-title');
    modal.setAttribute('aria-describedby', 'wdr-desc');
    modal.setAttribute('tabindex', '-1');

    modal.innerHTML =
      '<div class="wdr-header">' +
        '<div class="wdr-icon" aria-hidden="true">' +
          '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">' +
            '<circle cx="12" cy="12" r="10"/>' +
            '<line x1="12" y1="8" x2="12" y2="12"/>' +
            '<line x1="12" y1="16" x2="12.01" y2="16"/>' +
          '</svg>' +
        '</div>' +
        '<span class="wdr-title" id="wdr-title">FITMENT RESTRICTION</span>' +
      '</div>' +
      '<div class="wdr-bar"></div>' +
      '<div class="wdr-body">' +
        '<p class="wdr-desc" id="wdr-desc">' + POPUP_MESSAGE + '</p>' +
        '<p class="wdr-subheading">SELECT ONE OF THE AVAILABLE DESIGNS:</p>' +
        '<div class="wdr-chips">' +
          '<a href="https://daoffset.com/products/holes-hdd-5?variant=47259323203810">Holes HDD</a>' +
          '<a href="https://daoffset.com/products/classic-hdd-1?variant=47259323171042">Classic HDD</a>' +
          '<a href="https://daoffset.com/products/axis-hdd-f11?variant=47259322679522">Axis HDD</a>' +
          '<a href="https://daoffset.com/products/cane-hdd-f13?variant=47259322712290">Cane HDD</a>' +
          '<a href="https://daoffset.com/products/evo-hdd-g17?variant=47259323138274">Evo HDD</a>' +
          '<a href="https://daoffset.com/products/independence-hdd-11?variant=47259323269346">Independence HDD</a>' +
          '<a href="https://daoffset.com/products/hd-hdd-95?variant=47259323334882">HD HDD</a>' +
        '</div>' +
      '</div>' +
      '<div class="wdr-footer">' +
        '<button type="button" class="wdr-btn" aria-label="Acknowledge fitment restriction and close dialog">GOT IT</button>' +
      '</div>';

    document.body.appendChild(overlay);
    document.body.appendChild(modal);

    var focusableElements = modal.querySelectorAll('a[href], button');
    var firstFocusable = focusableElements[0];
    var lastFocusable = focusableElements[focusableElements.length - 1];

    // Apply visual focus state directly via inline styles (bypasses all CSS specificity issues)
    function applyFocusStyle(el) {
      if (!el) return;
      // Only style chip links, not the GOT IT button (it has its own styling)
      if (el.parentElement && el.parentElement.classList.contains('wdr-chips')) {
        el.style.setProperty('background', '#ffffff', 'important');
        el.style.setProperty('color', '#B1282E', 'important');
        el.style.setProperty('outline', '3px solid #111111', 'important');
        el.style.setProperty('outline-offset', '2px', 'important');
      }
    }

    function removeFocusStyle(el) {
      if (!el) return;
      if (el.parentElement && el.parentElement.classList.contains('wdr-chips')) {
        el.style.removeProperty('background');
        el.style.removeProperty('color');
        el.style.removeProperty('outline');
        el.style.removeProperty('outline-offset');
      }
    }

    // Attach focus/blur listeners to each chip
    for (var i = 0; i < focusableElements.length; i++) {
      var el = focusableElements[i];
      el.addEventListener('focus', function (e) { applyFocusStyle(e.target); });
      el.addEventListener('blur', function (e) { removeFocusStyle(e.target); });
    }

    if (firstFocusable) firstFocusable.focus();

    function handleKeydown(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        closePopup();
        return;
      }

      if (e.key === 'Tab') {
        if (focusableElements.length === 0) {
          e.preventDefault();
          return;
        }
        if (e.shiftKey && document.activeElement === firstFocusable) {
          e.preventDefault();
          lastFocusable.focus();
        }
        else if (!e.shiftKey && document.activeElement === lastFocusable) {
          e.preventDefault();
          firstFocusable.focus();
        }
      }
    }

    document.addEventListener('keydown', handleKeydown);

    function closePopup() {
      document.removeEventListener('keydown', handleKeydown);
      if (document.body.contains(overlay)) document.body.removeChild(overlay);
      if (document.body.contains(modal)) document.body.removeChild(modal);
      if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
        previouslyFocused.focus();
      }
    }

    var btn = modal.querySelector('.wdr-btn');
    if (btn) btn.addEventListener('click', closePopup);
    overlay.addEventListener('click', closePopup);
  }

  // -----------------------------
  // Core logic
  // -----------------------------
  function checkRestrictions(snapshot) {
    var snap = snapshot || getSelectedSnapshot();
    var restrictedDesign = isRestrictedDesignOnPage();
    var restrictedVehicle = isRestrictedVehicleSelected(snap);
    var restricted = restrictedDesign && restrictedVehicle;

    if (DEBUG) {
      try {
        console.log('[Design+Vehicle Restrict] title=', getProductTitle());
        console.log('[Design+Vehicle Restrict] snapshot=', snap);
        console.log('[Design+Vehicle Restrict] restricted=', restricted);
      } catch (e) {}
    }

    setAddToCartDisabled(restricted);
    if (restricted && !hasShownPopupForCurrentCombo) {
      showPopup();
    }
  }

  // -----------------------------
  // Watcher
  // -----------------------------
  function startStateWatcher() {
    setInterval(function () {
      var snap = getSelectedSnapshot();
      var title = getProductTitle();
      var stateKey = snap + ' || ' + title;
      if (stateKey !== lastStateKey) {
        lastStateKey = stateKey;
        hasShownPopupForCurrentCombo = false;
        checkRestrictions(snap);
      }
    }, 250);
  }

  // -----------------------------
  // Init
  // -----------------------------
  function init() {
    if (!isRestrictedDesignOnPage()) return;
    injectStyles();
    preventAddToCartWhenRestricted();
    startStateWatcher();
    checkRestrictions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();